import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import WeddingEventUpgrade from './WeddingEventUpgrade';
import withModal from '../../../../components/global/modal/withModal';
import { getAsset } from '../../../../util/assets';
import DismissButton from '../../../../components/global/DismissButton';

export const WEDDING_EVENT_UPGRADE_MODAL = 'modal/WEDDING_EVENT_UPGRADE';

const propTypes = {
  onRequestClose: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  className: PropTypes.string,
};

const WeddingEventUpgradeModal = ({
  onRequestClose,
  onClose,
  className,
  ...props
}) => {
  const classes = classNames({
    'wedding-event-purchase': true,
    [className]: !!className,
  });

  return (
    <div className={classes}>
      <DismissButton
        onClick={() => {
          onClose?.();
          onRequestClose?.();
        }}
        className="wedding-event-purchase-dismiss"
      />
      <img
        src={getAsset('/waldo-top-hat.png')}
        alt="Unlock your potential"
        width="37"
        className="mb-2"
      />
      <h1 className="text-extra-bold mb-2">Your big day deserves the best!</h1>
      <p>
        Everyone&apos;s photos &amp; videos in one beautiful Waldo-fied gallery.
        <br /> Pick a plan below!
      </p>

      <WeddingEventUpgrade {...props} />
    </div>
  );
};

WeddingEventUpgradeModal.propTypes = propTypes;

export default withModal(WeddingEventUpgradeModal, {
  name: WEDDING_EVENT_UPGRADE_MODAL,
  className: 'wedding-event-purchase-modal',
  overlayClassName: 'wedding-event-purchase-modal-overlay',
  size: 'lg',
  type: 'full',
  dismissible: false,
});
